import { Link } from '@material-ui/core';
import React from 'react';

import { IUINotice, UINoticeActiveTrue } from '~/src/dash/api/console-api';
import { NoticeIcon } from '~/src/dash/components/icons/misc-icons';
import { Col, Cols, Text } from '~/src/dash/publicaUI';
import { publicaColors } from '~/src/dash/utils/colors';

import { getRoutePath, RouteChannelExisting } from '~/src/dash/router/routes';

interface IProps {
  uiNotices: Array<IUINotice>;
  currentPath: string;
  styleOverride?: React.CSSProperties;
  publisherID: string;
}

export const UINoticeTopbar = ({ uiNotices, styleOverride, publisherID }: IProps) => {
  const activeUiNotices = uiNotices.filter(
    (uiNotice: IUINotice) => uiNotice.Active === UINoticeActiveTrue,
  );
  return (
    <div
      style={{
        width: '65%',
        height: 'auto',
        backgroundColor: '#FEFFF4',
        borderRadius: '2px',
        position: 'absolute',
        left: '50%',
        transform: 'translate(-50%, 0)',
        zIndex: 99,
        ...(styleOverride || {}),
      }}
    >
      <Cols
        style={{
          padding: '8px 10px',
          alignItems: 'start',
        }}
      >
        <Col
          style={{
            paddingTop: '3px',
            paddingRight: '2px',
          }}
        >
          <NoticeIcon
            color={publicaColors.veryDarkGray}
            style={{ marginRight: '2', marginLeft: '2' }}
          />
        </Col>
        <Col>
          {activeUiNotices?.map((notice: IUINotice) => {
            if (notice.Name === 'Deactivate Channel Notice') {
              return (
                <>
                  <Text key={notice.ID} bold extraSmall>
                    {notice.Description}
                    {notice.Detail.split(',').map((siteID: string) => {
                      return (
                        <>
                          <Link
                            style={{ marginLeft: 2, marginRight: 2 }}
                            href={
                              '#' +
                              getRoutePath(
                                RouteChannelExisting,
                                { p: publisherID },
                                { ch: siteID.trim() },
                              )
                            }
                          >
                            {siteID.trim()}
                          </Link>
                        </>
                      );
                    })}
                    |
                    <Link
                      style={{ marginLeft: 2, marginRight: 2 }}
                      href={
                        'https://publica.zendesk.com/hc/en-us/articles/40835619830171-Automatic-Channel-Deactivation-Policy'
                      }
                    >
                      Help
                    </Link>
                  </Text>
                </>
              );
            } else {
              return (
                <Text key={notice.ID} bold extraSmall>
                  {notice.Detail ? notice.Description + ': ' + notice.Detail : notice.Description}
                </Text>
              );
            }
          })}
        </Col>
      </Cols>
    </div>
  );
};
